export const priority = {
  Normativa: 'Normativa',
  Tecnica: 'Técnica',
  Institucional: 'Institucional',
};

export const userCourse = {
  status: {
    aprove: 'Aprobado',
    pendingCourses: 'Por Cursar',
  },
};

export const CourseTypes = {
  Enterprise: 'Enterprise',
  Department: 'Department',
  JobTitle: 'JobTitle',
};

export const FormatDate = 'YYYY-MM-DD';

export const ErrorMessage = {
  incorrectDate: 'Incorrect date',
  inactiveUser: 'Inactive user',
  incorrectPassword: 'La contraseña no es correcta',
  employeeNumberNotFound: 'Número de empleado no encontrado',
};

export default {
  priority,
  userCourse,
  ErrorMessage,
};
